import { Exclude, Expose, Type } from 'class-transformer';

import { BaseModel } from '@core/data-access';

@Exclude()
export class ApplicationUploadLinkDto extends BaseModel {
  @Expose() fileName!: string;
  @Expose() mimeType!: string;
  @Expose() @Type(() => Number) size!: number;
}
